import React from "react";

interface PlayPalsProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

const PlayPals: React.FC<PlayPalsProps> = ({
  title = "PlayPals",
  subtitle = "Find Games Near You",
  description = "Discover pickup games happening in your area! Whether it's cricket, pickleball, running clubs, or any sport you love — find local games, join a squad, and get moving. Your next adventure is just around the corner.",
}) => {
  return (
    <div className="flex items-center justify-center w-full bg-black text-white px-6 py-16 md:py-24 md:px-12 lg:px-20">
      <div className="relative max-w-6xl mx-auto w-full">
        <div className="relative flex flex-col md:flex-row items-center gap-8 bg-transparent rounded-lg">
          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative w-[80%] sm:w-[75%] md:w-[548px] h-auto">
              <div className="w-full aspect-square bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500 rounded-[32px] flex items-center justify-center p-4">
                <div className="text-center relative w-full h-full flex items-center justify-center">
                  {/* Map pin with sports ball inside */}
                  <div className="relative w-56 h-72 sm:w-64 sm:h-80 md:w-72 md:h-96">
                    {/* Location pin shape */}
                    <svg className="w-full h-full text-white" viewBox="0 0 64 80" fill="currentColor">
                      <path d="M32 0C18.745 0 8 10.745 8 24c0 18 24 40 24 40s24-22 24-40C56 10.745 45.255 0 32 0z" />
                    </svg>
                    {/* Sports icons inside pin */}
                    <div className="absolute top-8 sm:top-10 md:top-12 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2">
                      {/* Cricket ball / sports ball */}
                      <svg className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 text-emerald-500" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="white" />
                        <path d="M7 12c0-2.76 2.24-5 5-5" stroke="white" strokeWidth="1.5" fill="none" />
                        <path d="M17 12c0 2.76-2.24 5-5 5" stroke="white" strokeWidth="1.5" fill="none" />
                      </svg>
                      {/* Running person */}
                      <svg className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 text-emerald-500" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Text Content Section */}
          <div className="w-full md:w-1/2 px-4 sm:px-8 md:px-6 flex flex-col justify-center text-center md:text-left">
            <h3 className="text-emerald-500 text-lg sm:text-xl font-semibold mb-2 font-robotoSerif">
              {subtitle}
            </h3>
            <h2 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold font-inter leading-tight">
              {title}
            </h2>
            <p className="text-gray-300 text-base sm:text-lg font-dmSans mt-4">
              {description}
            </p>
            <div className="w-full max-w-md mx-auto md:mx-0 mt-6">
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <span className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-lg px-6 py-3 font-semibold">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z" />
                  </svg>
                  Coming Soon
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayPals;
